import React, { useEffect } from 'react';
import { ENTER } from '../ISRConstants';
import TextField from 'Components/DesignSystem/TextField/TextField';

type TFractionalInputProps = {
    id: string;
    fieldName: string;
    value: string | number | undefined;
    handleInputChange: (value: string) => void;
    errors: { [key: string]: string | null };
    setErrors: React.Dispatch<React.SetStateAction<{ [key: string]: string | null }>>;
    /**
     * Accessible name. The visible label sits in the parent, beside an info icon, so
     * this control has nothing to name itself with — it rendered a bare unlabelled
     * input before.
     */
    ariaLabel?: string;
    /**
     * Test hook. The input used to hardcode `components-fractionalinput-input-1`,
     * which put THREE elements with the same testid on the Fraction panel (min, max
     * and default value). A shared component must forward this, never own it.
     */
    'data-testid'?: string;
}

const FractionalInput = ({
    id,
    fieldName,
    value,
    handleInputChange,
    errors,
    setErrors,
    ariaLabel,
    'data-testid': dataTestId,
}: TFractionalInputProps) => {

    useEffect(() => {
        validateFractionalValue();
    }, [value]);

    const validateFractionalValue = () => {
        const regex = /^\d+$|^\d+\s*\/\s*(?!\d+$)\d+$|^\d+(?:\s+\d*)?\/\d+$|^\d+-\d+\s*\/\s*\d+$/;
        const errorMessage = value && !regex.test(value.toString()) ? 'Invalid fraction' : null;
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    };

    return (
        <div id={id}>
            <div id={`${id}-container`} className="tw-flex tw-items-center">
                <TextField
                    id={`${id}-input`}
                    data-testid={dataTestId ?? 'components-fractionalinput-input-1'}
                    label=""
                    aria-label={ariaLabel}
                    value={String(value ?? '')}
                    onChange={handleInputChange}
                    placeholder={ENTER}
                    error={Boolean(errors?.[fieldName])}
                    className="tw-w-full"
                />
            </div>
        </div>
    );
};

export default FractionalInput;
